import { useState } from "react";

import {
  nameValidation,
  passwordValidator,
} from "../../validations/loginUserValidator";

import { handleServerValidations } from "../../utils/handleServerValidations";

export const LoginUserForm = ({ setIsOpenIn, setUserName, showPassword }) => {
  // autocompleta nombre de session previa
  let storedUser = sessionStorage.getItem("expiredUserData");
  storedUser = storedUser && JSON.parse(storedUser);
  const [name, setName] = useState(storedUser ? storedUser : "");
  storedUser && sessionStorage.removeItem("expiredUserData");

  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    //Checkea validacioses del front en cada input
    let testValidations = [
      nameValidation(document.querySelector("#name"), ".error-message-name"),
      passwordValidator(
        document.querySelector("#password"),
        ".error-message-password",
      ),
    ];
    //Si existe alguna finaliza la funcion
    if (testValidations.includes(false)) {
      return;
    }
    // envía la informacion del formulario al metodo de login
    const formInfo = {
      name,
      password,
    };
    try {
      const response = await fetch(
        (process.env.NODE_ENV === "production" ? "https://" : "http://") + process.env.REACT_APP_API_URL + "/api/user/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formInfo),
          credentials: "include",
        },
      );
      // Maneja la respuesta segun el status de la respuesta
      switch (response.status) {
        // obtiene el nombre de usuario y lo gaurda en estado
        case 200:
          const userData = await response.json();
          setUserName(userData.userName);
          setIsOpenIn("");
          break;
        case 400:
          //Maneja los errores del formulario del servidor
          const formErrors = await response.json();
          //Manejo de validaciones del servidor
          formErrors.errors.name &&
            handleServerValidations(
              "#name",
              ".error-message-name",
              formErrors.errors.name.msg,
            );
          formErrors.errors.password &&
            handleServerValidations(
              "#password",
              ".error-message-password",
              formErrors.errors.password.msg,
            );

          break;
        case 500:
          //Manejo de mensaje de error en el servidor
          const serverError = await response.json();
          console.log("Error del servidor:", serverError);
          break;
        default:
          break;
      }
    } catch (error) {
      console.log("Error en el fetch de logeo", error);
    }
  };

  return (
    <form className="reset-form-class login-register-form-container">
      <button type="submit" disabled hidden aria-hidden="true"></button>
      <div>
        <label htmlFor="name">Nombre de usuario:</label>
        <input
          id="name"
          type="text"
          value={name}
          onInput={(e) => {
            setName(e.target.value);
            nameValidation(e.target, ".error-message-name");
          }}
          onFocus={(e) => {
            nameValidation(e.target, ".error-message-name");
          }}
        />
        <p className="err-message error-message-name"></p>
      </div>
      <div className="field-password">
        <i
          className="fa-regular fa-eye-slash"
          onClick={(e) => showPassword("#password", e.target)}
        ></i>

        <label htmlFor="password">Contraseña:</label>
        <input
          id="password"
          type="password"
          placeholder=""
          onInput={(e) => {
            setPassword(e.target.value);
            passwordValidator(e.target, ".error-message-password");
          }}
          onFocus={(e) => {
            passwordValidator(e.target, ".error-message-password");
          }}
        />
        <p className="err-message error-message-password"></p>
      </div>
      <div className="modal-box-btns">
        <button
          className="green-button"
          type="button"
          onClick={() => handleLogin()}
        >
          Ingresar
        </button>
        <button
          className="red-button"
          type="button"
          onClick={() => setIsOpenIn("")}
        >
          Cancelar
        </button>
      </div>
    </form>
  );
};
